import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { SideNav as BaseSideNav } from '@urbantxt/navigation';
import { matchRuleForPath } from 'access';
import { UserTypeTag } from 'components/Tags/UserTypeTag';
import useNavigationLinks from 'hooks/useNavigationLinks';
import useLogout from 'hooks/useLogout';
import useIsMobile from 'hooks/useIsMobile';
import useSideMenuStore from 'store/useSideMenuStore';
import useUserStore from 'store/useUserStore';

export default function SideNav() {
  const { links } = useNavigationLinks();
  const location = useLocation();
  const isOpen = useSideMenuStore(s => s.show);
  const hideSideMenu = useSideMenuStore(s => s.hide);
  const openSideMenu = useSideMenuStore(s => s.open);
  const user = useUserStore(s => s.user);
  const { logout } = useLogout();
  const { isMobile } = useIsMobile();

  const userProfile = useMemo(
    () =>
      user
        ? {
            displayName: `${user.firstName} ${user.lastName}`,
            avatarSrc: `https://robohash.org/${user._id}`,
            badge: <UserTypeTag type={user.type} size="sm" />,
          }
        : null,
    [user],
  );

  return (
    <BaseSideNav
      links={links}
      pathname={location.pathname}
      brand={{
        railLabel: 'TXT',
        accent: 'TXT-',
        name: 'Rosie',
        homeAriaLabel: 'TXT Rosie home',
        navAriaLabel: 'Rosie navigation',
      }}
      isOpen={isOpen}
      isMobile={isMobile}
      onOpen={openSideMenu}
      onClose={hideSideMenu}
      onLogout={logout}
      userProfile={userProfile}
      activeOptions={{
        matchNodeWithoutTo: (node, pathname) =>
          matchRuleForPath(pathname).id === node.id,
      }}
    />
  );
}
